// src/services/userService.ts
import ApiService from './api';
import { User } from '../types';

class UserService {
  async getUsers(): Promise<User[]> {
    const token = localStorage.getItem('token');
    return ApiService.get<User[]>('/api/users', token || undefined);
  }

  async getUser(id: number): Promise<User> {
    const token = localStorage.getItem('token');
    return ApiService.get<User>(`/api/users/${id}`, token || undefined);
  }

  async createUser(user: Omit<User, 'id' | 'created_at'>): Promise<User> {
    const token = localStorage.getItem('token');
    return ApiService.post<User>('/api/users', user, token || undefined);
  }

  async updateUser(id: number, user: Partial<User>): Promise<User> {
    const token = localStorage.getItem('token');
    return ApiService.put<User>(`/api/users/${id}`, user, token || undefined);
  }

  async deleteUser(id: number): Promise<void> {
    const token = localStorage.getItem('token');
    return ApiService.delete<void>(`/api/users/${id}`, token || undefined);
  }
}

const userService = new UserService();
export default userService;